module.exports = __webpack_public_path__ + "static/media/athletes.86eece43.png";